import React from 'react';
import ConfirmModal from '../ConfirmModal';

const ProductAvailabilityDialog = ({ target, scope, saving, onChangeBranches, onConfirm, onClose, onRetry }) => {
  const ready = target && scope?.branchId === target.branchId && !scope.loading && !scope.error;
  const selected = target?.additionalBranchIds || [];
  const current = scope?.branches?.find((branch) => String(branch.id) === target?.branchId);
  return <ConfirmModal isOpen={Boolean(target)}
    title={target?.formatTarget
      ? (target.isAvailable ? '¿Marcar este formato disponible?' : '¿Marcar este formato no disponible?')
      : (target?.isAvailable ? '¿Marcar formatos visibles disponibles?' : '¿Marcar formatos visibles no disponibles?')}
    confirmLabel={saving ? 'Actualizando…' : target?.isAvailable ? 'Marcar disponible' : 'Marcar no disponible'}
    tone={target?.isAvailable ? 'primary' : 'warning'}
    confirmDisabled={!ready || saving} onConfirm={onConfirm} onCancel={saving ? () => {} : onClose}>
    <div className="mt-3 max-h-[55vh] space-y-3 overflow-y-auto text-sm text-slate-700">
      <p>{target?.formatTarget
        ? `Este cambio se aplicará a ${target.formatTarget.variety.name} · ${target.formatTarget.format.productFormatName || target.formatTarget.format.clientType || 'formato'}.`
        : `Este cambio se aplicará a ${target?.configuredCount} formatos configurados visibles de ${target?.product.name}. Los formatos sin precio se omitirán.`}</p>
      {!ready && !scope?.error && <p role="status">Cargando sucursales…</p>}
      {scope?.error && <div role="alert"><p>{scope.error}</p><button type="button" onClick={onRetry}
        className="font-semibold text-blue-700 underline">Reintentar</button></div>}
      {ready && scope.isMainBranch && <fieldset disabled={saving} className="space-y-2">
        <legend className="mb-2 text-sm font-semibold text-slate-900">¿Aplicar también en otras sucursales?</legend>
        <label className="flex items-center gap-2 rounded-md bg-slate-100 p-2">
          <input type="checkbox" checked disabled readOnly className="h-4 w-4" />
          <span>{current?.name || 'Sucursal principal'} <span className="text-xs text-slate-500">(principal, siempre incluida)</span></span>
        </label>
        {scope.branches.filter((branch) => String(branch.id) !== target.branchId).map((branch) => <label key={branch.id}
          className="flex cursor-pointer items-center gap-2 rounded-md border border-slate-200 p-2">
          <input type="checkbox" checked={selected.includes(branch.id)} className="h-4 w-4"
            onChange={(event) => onChangeBranches(event.target.checked ? [...selected, branch.id] : selected.filter((id) => id !== branch.id))} />
          <span>{branch.name}</span>
        </label>)}
        <p className="text-xs text-slate-600">Sin seleccionar otras sucursales, el cambio se aplicará solo a la principal. En cada sucursal se omitirán los formatos sin precio.</p>
        <p className="text-xs text-slate-600">Las ofertas, los precios y las reglas se conservarán.</p>
      </fieldset>}
      {target?.error && <p role="alert" className="text-red-700">{target.error}</p>}
    </div>
  </ConfirmModal>;
};

export default ProductAvailabilityDialog;
